import { CFormGroup, CInvalidFeedback, CLabel, CSelect } from "@coreui/react";

import React from "react";
import { FieldError } from "react-hook-form";

interface SelectFieldProps {
  name: string;
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  error?: FieldError;
  required?: boolean;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
  testId?: string;
}

const SelectField: React.FC<SelectFieldProps> = ({
  name,
  label,
  description,
  value,
  onChange,
  error,
  required = false,
  options,
  placeholder = "Select an option...",
  testId,
}) => {
  return (
    <CFormGroup>
      <CLabel htmlFor={name}>
        {label}
        {required && <span className="text-danger"> *</span>}
      </CLabel>
      {description && (
        <small className="form-text text-muted mb-2">{description}</small>
      )}
      <CSelect
        id={name}
        name={name}
        data-testid={testId}
        value={value}
        onChange={(e) => onChange((e.target as HTMLSelectElement).value)}
        invalid={!!error}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </CSelect>
      {error && <CInvalidFeedback>{error.message}</CInvalidFeedback>}
    </CFormGroup>
  );
};

export default SelectField;
